'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var _require = require('react-dom');

var findDOMNode = _require.findDOMNode;

var Link = require('cf-component-link');
var DropdownRegistry = require('./DropdownRegistry');

var DropdownLink = function (_React$Component) {
  _inherits(DropdownLink, _React$Component);

  function DropdownLink(props, context) {
    _classCallCheck(this, DropdownLink);

    if (!props.to && !props.onClick) {
      throw new Error('<DropdownLink/> requires either a `to` or `onClick` prop');
    }

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleLinkFocus = function (e) {
      _this.dropdownRegistry.setFocusedChild(_this);
    };

    _this.handleLinkBlur = function (e) {
      _this.dropdownRegistry.removeFocusedChild();
    };

    _this.dropdownRegistry = context.dropdownRegistry;
    return _this;
  }

  DropdownLink.prototype.componentWillMount = function componentWillMount() {
    this.dropdownRegistry.addChild(this);
  };

  DropdownLink.prototype.componentWillUnmount = function componentWillUnmount() {
    this.dropdownRegistry.removeChild(this);
  };

  DropdownLink.prototype.focus = function focus() {
    findDOMNode(this.refs.link).focus();
  };

  DropdownLink.prototype.render = function render() {
    return React.createElement(
      'li',
      { className: 'cf-dropdown__link', role: 'menuitem' },
      React.createElement(
        Link,
        { ref: 'link',
          to: this.props.to,
          onClick: this.props.onClick,
          onFocus: this.handleLinkFocus,
          onBlur: this.handleLinkBlur },
        this.props.children
      )
    );
  };

  return DropdownLink;
}(React.Component);

DropdownLink.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func
};
DropdownLink.contextTypes = {
  dropdownRegistry: PropTypes.instanceOf(DropdownRegistry).isRequired
};


module.exports = DropdownLink;